
export class Header {
  Version: number;
  SessionID: string;
  PrimaryEntityID: string;
  ViewTypeDID: string;
  ViewTemplateID: string;
  ViewID: string;
  AppStateID: string;
  Title: any;
  DocType: string;
  
  

  public static readonly EntityViewASDID = '5f3de6d9-1e9c-4bd9-9187-eb8157549c44';
  public static readonly ListViewASDID = 'c1378342-c1fe-4ee3-9df6-e46c90780a9c';
}
